import { Component, OnInit } from '@angular/core';

@Component({
    selector: "app-service-maintenance-industrielle",
    templateUrl: "./service-maintenance-industrielle.component.html",
    styleUrls: ["./service-maintenance-industrielle.component.scss"],
})
export class ServiceMaintenanceIndustrielleComponent implements OnInit {
    constructor() {}

    ngOnInit() {}
}
